import { CardSkeleton } from "@ui/components/Card";

export interface ListingCardSkeletonProps {
  className?: string;
  withAuthor?: boolean;
}

export function ListingCardSkeleton({ className, withAuthor }: ListingCardSkeletonProps) {
  return withAuthor ? (
    <CardSkeleton className={className} withAuthor />
  ) : (
    <CardSkeleton className={className} lines={2} withPrice />
  );
}
